'use client';

import { createContext, useContext } from 'react';
import type { CustomizedShortcuts } from '../hooks/useCustomShortcutsStore';
import type { CommandKeys } from '../types/CommandKeys';

export type CustomShortcutsContextValue = {
  customizedShortcuts: CustomizedShortcuts;
  setShortcut: (id: string, keys: ReadonlyArray<CommandKeys>) => void;
  resetShortcut: (id: string) => void;
  resetMany: (ids: ReadonlyArray<string>) => void;
};

export const CustomShortcutsContext =
  createContext<CustomShortcutsContextValue | null>(null);

/**
 * Read the customized-shortcuts map and writers.
 *
 * Returns `null` when no provider is mounted — callers should treat that as
 * "customization is unavailable here" rather than throwing.
 */
export function useCustomShortcuts(): CustomShortcutsContextValue | null {
  return useContext(CustomShortcutsContext);
}
